const initialState = {
    isOpen: false,
    isActive: false,
    fname: '', 
    fnameErr: '',
    lname: '',
    lnameErr: '',
    nationalCode: '',
    nationalCodeErr: '', 
    birthDay: '',
    birthMonth: '',
    birthYear: '',
    showDayOptions: false,
    showMonthOptions: false,
    showYearOptions: false,
};
const modalEditPersonalInfo = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_MODAL_EDIT_PERSONAL_INFO':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default modalEditPersonalInfo;
